import { render, staticRenderFns } from "./ModalConfirmEmailToken.vue?vue&type=template&id=225dc5f4"
import script from "./ModalConfirmEmailToken.vue?vue&type=script&lang=js"
export * from "./ModalConfirmEmailToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports